import React from 'react';
import ViewPackagePaymentSettingComponent from '../../../Components/PackagePaymentSetting/ViewPackagePaymentSetting';

export default function ViewPackagePaymentSetting() {
    return (
        <div className='page-body'>
            <ViewPackagePaymentSettingComponent />
        </div>
    );
}